import { Component } from '@angular/core';

@Component({
  templateUrl: './context-menu.html'  
})
export class ContextMenuComponent { 

    constructor() {
      
    }

    ClickExample() {
      console.log('Click Example');
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/context-menu/context-menu-component.ts